<template>
  <div class="main-wrapper testimonials-page innerpagebg">
    <layouts-header></layouts-header>
    <breadcrumb :title="title" :text="text" :text1="text1" />
    <div class="content carousel-content">
      <div class="container">
        <div class="featured-slider-group p-0">
          <div class="owl-carousel testimonials-slider owl-theme">
            <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
              <Slide v-for="record in Testimonials" :key="record.id">
                <!-- Testimonials Item -->
                <div class="testimonial-group">
                  <div class="testimonial-review text-start">
                    <div class="rating-point">
                      <i class="fas fa-star filled"></i>
                      <i class="fas fa-star filled ms-1"></i>
                      <i class="fas fa-star filled ms-1"></i>
                      <i class="fas fa-star filled ms-1"></i>
                      <i class="fas fa-star filled ms-1"></i>
                      <span> 5.0</span>
                    </div>
                    <h5>Finibus mauris. Aliquam consectetur</h5>
                    <p>
                      {{ record.Topic }}
                    </p>
                  </div>
                  <div class="listing-venue-owner">
                    <a class="navigation">
                      <img
                        :src="require(`@/assets/img/profiles/${record.Image}`)"
                        alt="User"
                      />
                    </a>
                    <div class="testimonial-content">
                      <h5>{{ record.Name }}</h5>
                      <a href="javascript:void(0);" class="btn btn-primary">
                        {{ record.Sports }}
                      </a>
                    </div>
                  </div>
                </div>
                <!-- /Testimonials Item -->
              </Slide>
              <template #addons>
                <Navigation />
              </template>
            </Carousel>
          </div>
        </div>
      </div>
    </div>
  </div>
  <layout-footer></layout-footer>
</template>
<script>
import { Carousel, Navigation, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import Testimonials from "@/assets/json/testimonials.json";
export default {
  data() {
    return {
      Testimonials: Testimonials,
      title: "Testimonials Carousel",
      text: "Home",
      text1: "Testimonials Carousel",
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        767: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        991: {
          itemsToShow: 2,
          snapAlign: "start",
        },
        1024: {
          itemsToShow: 3,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Navigation,
  },
};
</script>
